import { Component, inject, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AlertMessageService } from 'src/app/services/alert-message/alert-message.service';
import { LoadingService } from 'src/app/services/loading/loading.service';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss']
})
export class LoadingIndicatorComponent implements OnInit {
  
  @Input() message: string = '';
  @Input() succeeded: boolean = false;
  @Input() failed: boolean = false;
  progress$: number | null = null;
  loading$: Observable<boolean>;
  
  constructor(
    private loadingService: LoadingService,
  ) {
    this.loading$ = this.loadingService.loading$;
  }

  async ngOnInit(): Promise<void> {

  }

}
